import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// External donation platform (Givebutter)
export const DONATE_URL = "https://givebutter.com/the-canary-report-kickoff-8yquhj";

// Substack newsletter
export const SUBSTACK_URL = "https://summernettles.substack.com";
export const SUBSTACK_EMBED = "https://summernettles.substack.com/embed";

// Print-on-demand storefront (Shopify)
export const STORE_URL = "https://the-canary-report.myshopify.com";

// Brand assets
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_photo-report-4/artifacts/8h9cukat_Horizontal_Logo.png";
export const MARK_URL =
  "https://customer-assets.emergentagent.com/job_photo-report-4/artifacts/y6cs4cfu_Canary_Icon.png";
export const BADGE_URL =
  "https://customer-assets.emergentagent.com/job_photo-report-4/artifacts/hihrgobt_ChatGPT%20Image%20Jul%204%2C%202026%2C%2005_25_06%20PM.png";
export const PRIMARY_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_photo-report-4/artifacts/8i6a1hfy_Primary_Logo.png";

// Parent company
export const GPM_URL = "https://www.greaterpurposemedia.com/";

export const SOCIALS = {
  brand: [
    { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61590594417765" },
    { name: "LinkedIn", url: "https://www.linkedin.com/showcase/the-canary-report" },
    { name: "TikTok", url: "https://www.tiktok.com/@thecanaryreport?is_from_webapp=1&sender_device=pc" },
    { name: "YouTube", url: "https://youtube.com/@canary.report?si=N4xCT5hRZXDQZGV0" },
    { name: "Instagram", url: "https://www.instagram.com/thecanary.report?utm_source=qr" },
  ],
  founder: [
    { name: "Facebook", url: "https://www.facebook.com/summer.nettles/" },
    { name: "Instagram", url: "https://www.instagram.com/sumitup4u/" },
    { name: "TikTok", url: "https://www.tiktok.com/@sumitup4u?lang=en" },
  ],
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("canary_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
